<template>
<div class="interprovincial-wrap container" v-if="!isLoading">
  <div class="province-tabs" v-if="tabsList.length > 0">
    <el-tabs class="common-tabs" v-model="activeIndex" @tab-click="chooseTabsActive" :aria-label="`提供在${tabsList[0].name}和在${tabsList[1].name}`" :wzades="`提供在${tabsList[0].name}和在${tabsList[1].name}`">
      <el-tab-pane v-for="(item, i) in tabsList" :key="i" :label="item.name" :name="item.index"></el-tab-pane>
    </el-tabs>
    <div class="chose-area mt-40" aria-label="选择您当前所在的城市" wzades="选择您当前所在的城市">
      <p class="chose-area-title">{{ activeIndex == "1" ? "您当前所在的城市是哪里？" : "您要办理哪个城市的事？" }}</p>
      <p class="chose-area-tips">
        <i class="el-icon-warning-outline"></i>
        下列可选择的城市，即已开通通办服务，若没找到对应城市，即暂未开通通办服务。
      </p>
      <div class="chose-area-content">
        <div :class="['chose-area-item', {'active': item.areaCode == scopeDivisionsCode}]" v-for="(item, i) in scopeAreaList" :key="i" @click="chooseAreaActive(item, i)" tabindex="0">
          {{ item.areaName }}
          <span class="subname">({{ item.range }})</span>
          <p class="active-img" v-if="item.areaCode == scopeDivisionsCode">
            <i class="el-icon-check active-icon"></i>
          </p>
        </div>
      </div>
    </div>
    <div v-show="scopeDivisionsCode && (!scopeAreaList[choseAreaIndex].link || activeIndex != 2)">
      <div class="txt-tip mt-40" v-if="scopeAreaList.length > 0">
        <span v-if="activeIndex == '1'">请选择您要在{{ scopeAreaList[choseAreaIndex].areaName }}办理的{{ areaNameChinese }}市事项</span>
        <span v-else>请选择您要在{{ areaNameChinese }}市办理的{{ scopeAreaList[choseAreaIndex].areaName }}事项</span>
      </div>
      <TableView key="a" :itemsList="itemsList" :keyword="keyword" :departmentList="departmentList" :getListCall="getListFunc" />
      <Pagination :pageIndex="pageIndex" :totalRow="totalRow" :linktoPageCall="linktoPageFunc" :totalPage="totalPage" />
    </div>
  </div>
</div>
</template>

<script>
import TableView from '@/components/TableView.vue';
import Pagination from '@/components/pagination.vue';
import {
  outnetConfig,
  unitList,
  scopeProgramList,
  scopeAreaList2,
  scopeAreaList3
} from '@/assets/utils/controlApi';
export default {
  data() {
    return {
      isLoading: true,
      scopeDivisionsObj: sessionStorage.getItem("scopeDivisionsObj") ? JSON.parse(sessionStorage.getItem("scopeDivisionsObj")) : null,
      areaNameChinese: sessionStorage.getItem("areaNameChinese"),
      loadingInstance: null,
      keyword: "",
      scopeRange: 11, //通办类型(11: 跨省通办 ； 12：全省跨市通办；  13：全市跨区通办 )
      activeIndex: "1",
      choseAreaIndex: 0,
      scopeDivisionsCode: '',
      tabsList: [{
        name: `外省可办的${sessionStorage.getItem("areaNameChinese")}事项`,
        index: "1"
      }, {
        name: `${sessionStorage.getItem("areaNameChinese")}可办的外省事项`,
        index: "2"
      }],
      departmentList: [], // 服务部门列表
      itemsList: [], // 事项列表
      pageIndex: 1,
      totalRow: 0,
      totalPage: 1,
      scopeAreaList: [], //跨域通办地区列表
    }
  },
  components: {
    TableView,
    Pagination
  },
  methods: {
    // 通过外网参数获取跨省通办的tab数据
    getAreaList() {
      return outnetConfig({
        key: 'CrossProvinceTabs'
      }).then(async(res) => {
        if (res.status == '200') {
          let value = res.data ? JSON.parse(res.data.value) : [];
          console.log("===跨省通办===", value)
          this.scopeAreaList = value;
          if (this.scopeAreaList.length > 0) {
            if (this.scopeDivisionsObj) {
              this.activeIndex = this.scopeDivisionsObj.activeIndex;
              let scopeDivisionsCode = this.activeIndex == 1 ? this.scopeDivisionsObj.szdArea[1] : this.scopeDivisionsObj.handledArea[1];
              let index = this.scopeAreaList.findIndex(item => item.areaCode == scopeDivisionsCode);
              console.log("---index---", index, scopeDivisionsCode)
              this.scopeDivisionsCode = index > -1 ? scopeDivisionsCode : this.scopeAreaList[0].areaCode; //如果有选中的地区则回显，没有就显示第一个
              if (this.scopeAreaList[index].link && this.activeIndex == 2) {
                window.open(this.scopeAreaList[index].link)
              } else {
                await this.getUnitList();
                this.getScopeProgramList();
              }
              // 回显完之后清楚缓存数据
              sessionStorage.removeItem("scopeDivisionsObj");
            }
          }
        } else {
          console.log(res.desc);
          this.loadingInstance ? this.loadingInstance.close() : "";
        }
      }).catch(err => {
        console.log(err)
        this.loadingInstance ? this.loadingInstance.close() : "";
      })
    },
    // 选择tabs
    async chooseTabsActive(e) {
      this.choseAreaIndex = 0;
      this.keyword = "";
      this.scopeDivisionsCode = "";
      console.log("---this.activeIndex--", this.activeIndex)
    },
    // 选择所属地
    async chooseAreaActive(item, i) {
      this.choseAreaIndex = i;
      this.scopeDivisionsCode = item.areaCode;
      if (this.scopeAreaList[i].link && this.activeIndex == 2) {
        window.open(this.scopeAreaList[i].link);
        return ;
      }
      this.loadingInstance = this.$loading.service({
        lock: true,
        text: "Loading"
      });
      await this.getUnitList();
      this.getScopeProgramList();
    },
    //分页回调
    linktoPageFunc(pageIndex) {
      this.loadingInstance = this.$loading.service({
        lock: true,
        text: "Loading"
      });
      console.log("---分页回调-")
      this.pageIndex = pageIndex;
      this.getScopeProgramList();
    },
    async getListFunc(approveName, serviceObject, unitCode) {
      this.loadingInstance = this.$loading.service({
        lock: true,
        text: "Loading"
      });
      console.log("---getListFunc-")
      this.keyword = approveName;
      await this.getUnitList(serviceObject);
      this.getScopeProgramList(approveName, serviceObject, unitCode);
    },
    // 获取外省可办的湛江事项地区
    getScopeAreaList2() {
      return scopeAreaList2({
        cityType: 1, //1：外省可办的湛江事项地区；3：省内可办的湛江事项地区
        scopeRange: this.scopeRange, //通办类型
        scopeShape: '01', //通办形式(01：一网通办 ；02：一窗通办 ；03：一体机通办)
        scopeDivisions: "", //通办区域(行政区划代码)
        pageRowNum: 9999,
        pageIndex: 1
      }).then((res) => {
        if (res.status == '200') {
          this.scopeAreaList = res.data.dataList
          if (this.scopeAreaList.length > 0) {
            if (this.scopeDivisionsObj) {
              let scopeDivisionsCode = this.scopeDivisionsObj.szdArea[1]
              let index = this.scopeAreaList.findIndex(item => item.areaCode == scopeDivisionsCode);
              console.log("---index---", index, scopeDivisionsCode)
              this.scopeDivisionsCode = index > -1 ? scopeDivisionsCode : this.scopeAreaList[0].areaCode; //如果有选中的地区则回显，没有就显示第一个
            } else {
              this.scopeDivisionsCode = this.scopeAreaList[0].areaCode
            }
          }
          console.log("---外省可办-2-", this.scopeAreaList, this.scopeDivisionsCode, this.activeIndex)
        } else {
          this.$message.error(res.desc);
        }
      })
    },
    getScopeAreaList3() {
      return scopeAreaList3({
        cityType: 2, //2、湛江可办的外省事项地区；4、湛江可办的省内事项地区
        scopeRange: this.scopeRange, //通办类型
        scopeShape: '01', //通办形式(01：一网通办 ；02：一窗通办 ；03：一体机通办)
        scopeDivisions: "", //通办区域(行政区划代码)
        pageRowNum: 9999,
        pageIndex: 1
      }).then((res) => {
        if (res.status == '200') {
          this.scopeAreaList = res.data.dataList
          if (this.scopeDivisionsObj) {
            let scopeDivisionsCode = this.scopeDivisionsObj.handledArea[1]
            let index = this.scopeAreaList.findIndex(item => item.areaCode == scopeDivisionsCode);
            console.log("---index---", index, scopeDivisionsCode)
            this.scopeDivisionsCode = index > -1 ? scopeDivisionsCode : this.scopeAreaList[0].areaCode; //如果有选中的地区则回显，没有就显示第一个
          } else {
            this.scopeDivisionsCode = this.scopeAreaList[0].areaCode
          }
          console.log("---外省可办-3-", this.scopeAreaList, this.scopeDivisionsCode)
        } else {
          this.$message.error(res.desc);
        }
      })
    },
    // 根据跨域通办获取单位列表信息（有事项的单位列表）
    getUnitList(serviceObject) {
      let param = {
        scopeRange: this.scopeRange,
        areaCode: "",
        scopeDivisions: "", //通办区域(行政区划代码)
        serviceObject: serviceObject, //个人传1，企业传2
        pageIndex: 1,
        pageRowNum: 9999
      }
      if (this.activeIndex == "1") {
        //外省可办的湛江事项：scopeDivisions=外省的行政区划代码
        param.areaCode = window.gdzjAreaCode;
        param.scopeDivisions = this.scopeDivisionsCode;
      } else if (this.activeIndex == "2") {
        //湛江可办的外省事项：areaCode=外省的行政区划代码
        param.areaCode = this.scopeDivisionsCode;
        param.scopeDivisions = window.gdzjAreaCode;
      }
      return unitList(param).then((res) => {
        let arr = [{
          unitName: "全部",
          unitSeq: "",
          pareUnitSeq: "",
          unitCode: "",
          pareUnitCode: "",
          unitUID: ""
        }]
        this.departmentList = [...arr, ...res.data.dataList];
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取跨域通办事项列表
    getScopeProgramList(approveName, serviceObject, unitCode) {
      if (this.tabsList.length == 0) {
        return false;
      }
      let param = {
        programName: approveName,
        scopeRange: this.scopeRange,
        areaCode: "",
        scopeDivisions: "", //通办区域(行政区划代码)
        serviceObject: serviceObject, //个人传1，企业传2
        unitCode: unitCode,
        pageIndex: this.pageIndex || 1,
        pageRowNum: 10
      }
      if (this.activeIndex == "1") {
        //外省可办的湛江事项：scopeDivisions=外省的行政区划代码
        param.areaCode = window.gdzjAreaCode;
        param.scopeDivisions = this.scopeDivisionsCode;
      } else if (this.activeIndex == "2") {
        //湛江可办的外省事项：areaCode=外省的行政区划代码
        param.areaCode = this.scopeDivisionsCode;
        param.scopeDivisions = window.gdzjAreaCode;
      }
      return scopeProgramList(param).then((res) => {
        if (res.status == '200') {
          this.itemsList = res.data.dataList;
          this.totalRow = res.data.pageObj.totalRow;
          this.totalPage = res.data.pageObj.totalPage;
          this.pageIndex = res.data.pageObj.currPage;
        } else {
          this.$message.error(res.desc);
        }
        this.loadingInstance ? this.loadingInstance.close() : "";
      }).catch(err => {
        console.log("err=>", err)
        this.loadingInstance ? this.loadingInstance.close() : "";
      })
    },
  },
  async mounted() {
    this.loadingInstance = this.$loading.service({
      lock: true,
      text: "Loading"
    });
    if (this.scopeDivisionsObj) {
      this.activeIndex = this.scopeDivisionsObj.activeIndex; //1外省可办的湛江事项 2湛江可办的外省事项
      // this.activeIndex == "1" ? await this.getScopeAreaList2() : await this.getScopeAreaList3();
    } else {
      // await this.getScopeAreaList2();
    }
    // getScopeAreaList2和getScopeAreaList3是通过事项反推地区列表，这个逻辑于20221110被废除，改回读外网参数配置（getAreaList）
    await this.getAreaList();
    this.loadingInstance ? this.loadingInstance.close() : "";
    this.isLoading = false;
  }
}
</script>

<style lang="scss" scoped>
.interprovincial-wrap {
  .province-tabs {
    margin-top: 70px;
    padding-bottom: 50px;

    .chose-area {
      font-size: 16px;

      .chose-area-title {
        font-weight: 500;
        color: #0D1C28;
        line-height: 22px;
      }

      .chose-area-tips {
        color: #727475;
        margin-top: 10px;
      }

    }

    .txt-tip {
      font-size: 16px;
      color: #0D1C28;
      font-weight: 500;
      line-height: 22px;
    }
  }
}
</style>
